import { Box, Button, Stack, Typography } from "@mui/material";
import ifec_board from "../../../media/ifec_board.png";
import ems_graphic from "../../../media/ems_graphic.png";
import SectionCard from "../../../components/SectionCard";

const projects = [
  {
    title: "Class-D Audio Amplifier",
    image: ifec_board,
    imageAlt: "Audio Amplifier circuit boards",
    bullets: [
      "Part of the 2024 International Future Energy Challenge in Austin, Texas.",
      "Built a Class-D audio amplifier with excellent audio quality, energy efficiency, and power density.",
      "Modular channel boards designed to be interchangeable across audio channels.",
    ],
    link: "https://energychallenge.weebly.com/",
    linkLabel: "Learn more",
  },
  {
    title: "Energy Management System",
    image: ems_graphic,
    imageAlt: "Energy Management System graphic visualization",
    bullets: [
      <>
        Monitors, controls, and optimizes energy usage in the{" "}
        <a
          href="https://engineering.usu.edu/ece/power/facilities/evr"
          rel="noreferrer"
          target="_blank"
          className="inline-link"
        >
          Electric Vehicle and Roadway (EVR)
        </a>{" "}
        test facility at Utah State University.
      </>,
      "Web front-end for remote monitoring and control of equipment in the EVR test facility.",
    ],
    link: "https://upel-microgrid.bluezone.usu.edu/",
    linkLabel: "View live EMS data",
  },
];

function ProjectEntry({ project, showDivider }) {
  return (
    <>
      <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
        <Box
          component="img"
          src={project.image}
          alt={project.imageAlt}
          sx={{
            width: { xs: "100%", sm: 140 },
            height: { xs: 200, sm: 140 },
            objectFit: "cover",
            borderRadius: 2,
            flexShrink: 0,
          }}
        />
        <Box>
          <Typography
            variant="subtitle1"
            color="primary"
            sx={{ fontWeight: 600, mb: 1 }}
          >
            {project.title}
          </Typography>
          <Box component="ul" className="entry-list">
            {project.bullets.map((bullet, index) => (
              <li key={index}>
                <Typography variant="body2" component="span">
                  {bullet}
                </Typography>
              </li>
            ))}
          </Box>
          <Button
            variant="outlined"
            href={project.link}
            target="_blank"
            rel="noreferrer"
            size="small"
            sx={{ mt: 1 }}
          >
            {project.linkLabel}
          </Button>
        </Box>
      </Stack>
      {showDivider && (
        <Box
          sx={{
            my: 2,
            borderBottom: "1px solid rgba(129, 203, 233, 0.15)",
          }}
        />
      )}
    </>
  );
}

export default function ProjectsSummary() {
  return (
    <SectionCard title="Projects">
      {projects.map((project, index) => (
        <ProjectEntry
          key={project.title}
          project={project}
          showDivider={index < projects.length - 1}
        />
      ))}
    </SectionCard>
  );
}
